import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export function cssBaseline(theme: Theme) {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          boxSizing: 'border-box',
        },
        html: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
        },
        body: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
        },
        '#root, #__next, #chat-widget-shadow-container': {
          width: '100%',
          height: '100%',
        },
        // Ensure the shadow DOM container has proper styling
        '#chat-widget-shadow-container': {
          fontFamily: 'inherit',
          fontSize: 'inherit',
          lineHeight: 'inherit',
          color: 'inherit',
          pointerEvents: 'none',
          overflow: 'hidden',
          '& *': {
            fontFamily: 'inherit',
          },
          // Ensure widget components can receive pointer events and proper overflow
          '& [data-widget-component]': {
            pointerEvents: 'auto',
          },
          '& [data-widget-component="chat-container"]': {
            overflow: 'hidden',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          },
          '& [data-widget-component="message-list"]': {
            flexGrow: 1,
            overflowY: 'auto',
            overflowX: 'hidden',
            WebkitOverflowScrolling: 'touch',
            msOverflowStyle: '-ms-autohiding-scrollbar',
          }
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        img: {
          maxWidth: '100%',
          display: 'inline-block',
          verticalAlign: 'bottom',
        },
      },
    },
  };
}
